import "./About.css"

import React, { useEffect } from 'react';

import { Globalalert, Navbar, Footer, Contact, Stats } from '../../components'
import { FaCreditCard } from "react-icons/fa";
import { SiVenmo } from "react-icons/si";
import { Helmet } from 'react-helmet'

import { Link } from "react-router-dom";

import recipesList from '../../data/recipesList';

function About() {
    return (
        <div id="about" className="site">
            <Helmet>
                <title>JD's Kitchen</title>
            </Helmet>
            
            <Navbar primaryColor="#fff" position='absolute'/>
            <section className="hero-banner">
                <div className="hero-container">
                    <div className="hero-content">
                        <h1>From a Corporate Office to Home Baker</h1>
                        <h2>A Cottage Food Baker</h2>

                        <p>On December 2024, I was unfortunately laid off from my corporate office job - </p>
                        <p>This micro-bakery is established with vision of sourcing quality ingredients, supporting reputable businesses, with the goal of some day opening up a bakery location on Convoy Street.</p>
                        <p>Now accepting Pre-Orders below, pick-up @ Kearny Mesa on Sundays from 9am-11am.</p>
                        <div className="btn-primary-container">
                            <a href="https://jds-kitchen.square.site" className="button-74" target="_blank" rel="noopener noreferrer">Pre-Order Now</a>
                        </div>
                    </div>
                    <div className="hero-image-container">
                        <img className="hero-image" src="/hero_background.png"/>
                    </div>
                </div>
            </section>

            <Contact />
            {/* <div className="inline-convertkit-form">
                <script async data-uid="ef302e56ce" src="https://jackydam.kit.com/ef302e56ce/index.js"></script>            
            </div> */}
            {/* <Footer /> */}
            

        </div >
    )
}

export default About